// @ts-check
import { makeAutoObservable } from "mobx";

/**
 * @typedef {object} AlertState
 * @property {number} key
 * @property {("success"|"warning"|"error")} type
 * @property {React.JSX.Element | string} text
 * @property {Date} createdAt
 * @property {boolean} autoClose
 * @property {{key: number, title: string, callback: () => void}[]} buttons
 * @property {boolean} hideCloseButton
 * @property {() => void} closeAlertHandler
 * @property {() => void} onInit
 * @property {() => void} onRelease
 */

const autoCloseDelayMSeconds = 10 * 1000;
const maxArchiveSize = 100;

class AlertsHolderStore {
    /** @type {AlertState | null} */
    currentAlert;
    /** @type {AlertState[]} */
    alertsArchive;
    archiveOpened;

    constructor() {
        makeAutoObservable(this);

        this.currentAlert = null;
        this.alertsArchive = [];
        this.archiveOpened = false;
    }

    /**
     * @param {AlertState} alert 
     */
    ShowAlert(alert) {
        let oldAlert = this.currentAlert;

        let newAlertClose = false;
        if (alert.type === "error") {
            this.alertsArchive.push(alert);
            if (this.alertsArchive.length > maxArchiveSize)
                this.alertsArchive.shift();
        }

        if (this.archiveOpened) {
            newAlertClose = true;
        }
        else {
            this.currentAlert = alert;

            if (alert.autoClose) {
                setTimeout(() => this.CloseAlert(alert.key, true), autoCloseDelayMSeconds);
            }
        }

        if (oldAlert != null) {
            oldAlert.onRelease();
        }

        alert.onInit();

        if (newAlertClose) {
            alert.onRelease();
        }
    }

    /**
     * @param {number} key 
     * @param {boolean} isAutomaticClose 
     */
    CloseAlert(key, isAutomaticClose) {
        if (this.currentAlert?.key == key)
            this.CloseCurrentAlert();

        if (!isAutomaticClose)
            this.DeleteAlertFromArchive(key);
    };

    CloseCurrentAlert() {
        let oldAlert = this.currentAlert;
        this.currentAlert = null;
        if (oldAlert != null) {
            oldAlert.onRelease();
        }
    }

    /**
     * @param {AlertState | null} alert
     */
    HandleAlertClose(alert) {
        if (alert == null)
            return;


    }

    /**
     * @param {boolean} state
     */
    ChangeArchiveOpenState(state) {
        if (this.archiveOpened === state)
            return;

        if (state === true)
            this.CloseCurrentAlert();

        this.archiveOpened = state;
    };

    ClearAlertsArchive() {
        this.alertsArchive = [];

        this.ChangeArchiveOpenState(false);
    }

    /**
     * @param {number} key
     */
    DeleteAlertFromArchive(key) {
        let index = this.alertsArchive.findIndex(x => x.key == key);

        if (index > -1)
            this.alertsArchive.splice(index, 1);

        if (this.alertsArchive.length === 0)
            this.ChangeArchiveOpenState(false);
    }
}

export default new AlertsHolderStore();